
import { defineComponent } from "vue";

export default defineComponent({
    name: "Location",
    props: {
        color: {
            type: String,
            default: "#333333",
        },
    },
});
